<template>
	<div :class="$style.notification">
		<BaseTooltip
			v-if="notification.date"
			position="right"
			:content="date"
		>
			<TimeAgo
				:class="[$style['color'],$style['color--grey']]"
				:timestamp="timestamp"
			/>
		</BaseTooltip>
		<p :class="$style['notification__title']" class="notification__title">
			{{ $t(`notifications.types.data-export.${notification.operationType}.title`) }}
		</p>
		<p
			v-if="notification?.totalOperations > 1"
			:class="$style['notification__notice']"
		>
			{{ $t('notifications.types.data-export.finished-updating') }}: <strong :class="$style['color--success']">{{ notification.totalOperations }}</strong>
		</p>
		<div
			v-if="hasDownloadLink"
			:class="$style['notification__buttons']"
		>
			<button
				:class="$style['notification__button']"
				@click="handleDownload"
			>
				<BaseRipple />
				{{ $t('common.actions.download') }}
			</button>
		</div>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons'
import moment from '@/packages/moment'
import TimeAgo from '@/components/Essentials/TimeAgo'
export default {
	name: 'DataExportNotification',
	components: {
		TimeAgo
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			icons: {
				faLongArrowRight
			}
		}
	},
	computed: {

		date () {
			if (this.notification.date) {

				return moment(this.notification.date).format('LLLL')
			}
			return null
		},
		timestamp () {
			if (this.notification.date) {

				return new Date(this.notification.date).getTime()
			}
			return null
		},
		hasDownloadLink () {
			return this.notification.hasLink || this.notification.filePath
		}
	},
	methods: {
		async handleDownload () {
			const { data } = await this.$apollo.mutate({
				mutation: gql`
					query NotificationLinkPresignedUrl ($payload: NotificationLinkPresignedUrlInput!){
						notificationLinkPresignedUrl (payload: $payload) {
							url
						}
					}
				`,
				variables: {
					payload: {
						resourceId: this.$auth().id,
						notificationType: this.notification.type,
						notificationReceiverType: this.notification.receiverType,
						notificationId: this.notification.id
					}
				}
			})
			try {
				if (!data || !data.notificationLinkPresignedUrl.url) {
					throw new Error()
				}
				if (data.errors) {
					throw data.errors
				}
				window.open(data.notificationLinkPresignedUrl.url)
			} catch (error) {
				this.$store.dispatch('Notification/ADD_ERROR_NOTIFICATION',  error)
			}
		}
	}
}
</script>
<style lang="scss" module>

.color {
    font-size: 12px;

    &--grey {
        color: getColor(caption);
    }

    &--primary {
        color: getColor(tertiary);
    }

    &--success {
        color: getColor(success);
    }

    &--danger {
        color: getColor(danger);
    }
}

.notification {
    font-size: 14px;

    &__title {
        margin: 5px 0;
        font-size: 16px;
    }

    &__notice {
        margin: 0 0 10px;
        font-size: 14px;
        color: getColor(helper-text);
    }

    &__button {
        display: flex;
        align-items: center;
        appearance: none;
        border: 1px solid getColor(tertiary-light);
        font-size: 14px;
        border-radius: 4px;
        color: getColor(tertiary);
		margin-top: $gutter;
        text-decoration: none;
        padding: $gutter $gutter * 2;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: getColor(tertiary-bg);
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

        &:hover {
            background-color: getColor(tertiary-bg-hover);
            color: getColor(tertiary-light);
        }

        &:active,
        &:focus {
            outline: 0;
        }

        &:nth-child(2) {
            margin-left: 10px;
        }

        &--danger {
            color: getColor(danger);
            background-color: getColor(danger-bg);
            border: none;

            &:hover {
                background-color: getColor(danger-bg-hover);
                color: getColor(danger-light);
            }
        }
    }

    &__button-icon {
        margin-left: 7.5px;
        font-size: 16px;
    }
}
</style>
